import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router";

import * as Api from "@/api";
import Valkyrie, { viArrowRight, viCheck, viSpinnerThird, viTriangleExclamation } from "@sippy-platform/valkyrie";

import { Button, Stack, Typography } from "@mui/material";

import AuthUI from "./AuthUI";

export default function ConfirmEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const pbx = useSelector((state) => state.pbx);
  const auth = useSelector((state) => state.auth);

  const token = searchParams.get("token");
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [previousToken, setPreviousToken] = useState(token);

  if (token !== previousToken) {
    setPreviousToken(token);
    setLoading(true);
    setSuccess(false);
  }

  useEffect(() => {
    Promise.resolve(Api.putVerifyEmail(token))
      .then(() => setSuccess(true))
      .finally(() => setLoading(false));
  }, [navigate, auth.id, pbx, token]);

  return (
    <AuthUI>
      <title>{`Confirm email address \u00b7 ${import.meta.env.SIPPY_APP_TITLE}`}</title>
      <Typography variant="h4" sx={{ m: 0 }}>
        Confirm email address
      </Typography>
      <Stack
        direction="row"
        sx={{
          alignItems: "flex-start",
          gap: 1,
          mb: 2,
        }}
      >
        <Valkyrie
          icon={success ? viCheck : loading ? viSpinnerThird : viTriangleExclamation}
          spin={loading}
          style={{ marginTop: 6 }}
        />
        <Typography>
          {success
            ? "Email address confirmed."
            : loading
              ? "Confirming email address..."
              : "We couldn't confirm this email address. Check if the link hasn't expired already or the email address has already been confirmed."}
        </Typography>
      </Stack>
      <Button
        variant="contained"
        onClick={() => navigate("/")}
        size="large"
        type="button"
        endIcon={<Valkyrie icon={viArrowRight} />}
        disabled={loading}
      >
        Continue
      </Button>
    </AuthUI>
  );
}
